import { AttributeValues, useModelService } from 'services/model/model.service';
import { useBreadcrumbStore } from 'hooks/state/useBreadcrumbStore';
import { DateRange } from 'components/filter/input/DateRangePicker/types';
import { useDrilldownCoreColumnsCellExporters } from 'pages/trading/outlier/DrilldownCoreColumns';
import { DataTableExportConfigOptions } from 'components/table/DataTableExportUtil';

const DRILLDOWN_ATTRIBUTES = ['prdCategory', 'dateRange', 'chnCountry', 'chnMarketplace', 'prdBrand', 'prdNumber'];

export const useBreadcrumbPathString = () => {
  const { getAttribute } = useModelService();
  const chnCountry = getAttribute('chnCountry');

  const { breadcrumbs } = useBreadcrumbStore();

  return breadcrumbs
    .filter(b => b.filters && b.filters.length > 0)
    .flatMap(b => {
      return b.filters
        ?.filter(bf => bf.values && bf.values[0])
        .filter(bf => DRILLDOWN_ATTRIBUTES.includes(bf.attribute))
        .map(bf => {
          switch (bf.attribute) {
            case 'prdCategory':
            case 'chnMarketplace':
            case 'prdBrand':
            case 'prdNumber':
              return bf.values[0];
            case 'dateRange': {
              const dr: DateRange = bf.values[0] as DateRange;
              return dr.from ? dr.from.toISOString().slice(0, 10).replace(/-/g, '') : '';
            }
            case 'chnCountry': {
              return chnCountry.getValue({ chnCountry: bf.values[0] } as AttributeValues);
            }
          }
        })
        .flat();
    })
    .join('-');
};

export const useCoreDrilldownExportConfigOptions = (exportName: string) => {
  const pathString = useBreadcrumbPathString();

  const coreCellExporters = useDrilldownCoreColumnsCellExporters();

  const exportConfigOptions: DataTableExportConfigOptions = {
    exportName: `${pathString}-${exportName}`,
    skippedColumns: ['artImageUrl'],
    customCellValueExporters: coreCellExporters,
  };

  return exportConfigOptions;
};
